"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INVITATION_TTL_DAYS = void 0;
/** 邀请有效期。7 天：够转发、够对方找到时间处理，又不至于长期有效 */
exports.INVITATION_TTL_DAYS = 7;
//# sourceMappingURL=members.js.map